import { render, staticRenderFns } from "./orderMenu.vue?vue&type=template&id=30be77fc&scoped=true&"
import script from "./orderMenu.vue?vue&type=script&lang=js&"
export * from "./orderMenu.vue?vue&type=script&lang=js&"
import style0 from "./orderMenu.vue?vue&type=style&index=0&id=30be77fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30be77fc",
  null
  
)

export default component.exports